import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  loader: boolean = false;
  constructor(private toastr: ToastrService) {}

  showSuccess(message: any) {
    this.toastr.success(message);
  }
  showError(message: any) {
    this.toastr.error(message);
  }
  showInfo(message: any) {
    this.toastr.info(message);
  }

  showLoader() {
    this.loader = true;
  }
  hideLoader() {
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  }
}
